import React from 'react';
import { connect } from 'react-redux';
import { getUserPhoneNumber, updateUserPhoneNumber } from '../../../actions/userPhoneNumber';

const withUserPhoneNumber = (WrappedComponent) => {
  class WithUserPhoneNumber extends React.Component {
    state = { 
      loading: false,
      loaded: false 
    };

    async componentDidMount() {
      if (this.state.loaded) return;
      try {
        this.setState({ loading: true });
        await this.props.getUserPhoneNumber();
        this.setState({ loaded: true, loading: false });
      } catch (error) {
        console.error('Error fetching phone number:', error);
        this.setState({ loading: false });
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          phoneNumberLoading={this.state.loading}
          phoneNumberLoaded={this.state.loaded}
        />
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      userPhoneNumber: state.userPhoneNumber?.data || {},
    };
  };

  const mapDispatchToProps = {
    getUserPhoneNumber,
    updateUserPhoneNumber,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithUserPhoneNumber);
};

export default withUserPhoneNumber;